module.exports = __webpack_public_path__ + "static/media/courtney-cook-Q1T4XGEXIgw-unsplash.4290f0f4.jpg";